import { parse } from 'yaml';

/** Parses one YAML definition or an array of definitions from an uploaded file. */
export const parseYamlDefinitions = (content: string): unknown[] => {
  let parsed: unknown;
  try {
    parsed = parse(content);
  } catch (error) {
    throw new Error(
      `Unable to parse YAML: ${
        error instanceof Error ? error.message : 'unknown error'
      }`,
    );
  }

  if (Array.isArray(parsed)) {
    if (parsed.length === 0) {
      throw new Error('The YAML file does not contain any definitions.');
    }
    return parsed;
  }

  if (parsed !== null && typeof parsed === 'object') {
    return [parsed];
  }

  throw new Error('The YAML file must contain one definition or an array.');
};
